let teacherOverTImeIds = [
  'selectSchoolId',
  'teacherOverTimeToolId',
  'teacherOverTimeTeacherId'
];

teacherOverTImeIds.forEach((id) => {
  $('#' + id).selectize();
});

const $schoolIdSelect = $('#selectSchoolId');
$schoolIdSelect.change((e) => e.target.form.submit());